import * as React from 'react';

import classnames from 'classnames';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {InboxStatusFragment_enrollmentFormStatus as EnrollmentFormStatus} from 'nutshell-graphql-types';

import {getShouldShowErrorBanner} from './helpers';

import styles from './enrollment-form-banner.module.css';

type Props = {
    enrollmentFormStatus: EnrollmentFormStatus;
};

export function EnrollmentFormBanner(props: Props) {
    const enrollmentFormStatus = props.enrollmentFormStatus.status;
    const shouldShowErrorBanner = getShouldShowErrorBanner(enrollmentFormStatus);
    if (!shouldShowErrorBanner) {
        return null;
    }

    const isError = enrollmentFormStatus === 'CONTACT_SUPPORT';
    const isUnderReview =
        enrollmentFormStatus === 'SUBMISSION_VALIDATING' || enrollmentFormStatus === 'UNDER_REVIEW';

    const containerClassName = classnames(styles.container, {
        [styles['container--error']]: isError,
        [styles['container--success']]: isUnderReview,
    });

    return (
        <div className={containerClassName}>
            {isError && (
                <>
                    <Body color='error' size='small'>
                        Your registration form has been declined due to some errors within the
                        submission. This could be due to some missing or incorrect information
                        provided. Please{' '}
                        <Link size='small' variant='primary' href='https://support.nutshell.com'>
                            contact our support team
                        </Link>{' '}
                        so we can assist you with reviewing your submission.
                    </Body>
                    {props.enrollmentFormStatus.enrollmentForm &&
                        props.enrollmentFormStatus.enrollmentForm.twilioRejectionReasons && (
                            <Body color='error' size='small'>
                                Error message:
                                {props.enrollmentFormStatus.enrollmentForm.twilioRejectionReasons}
                            </Body>
                        )}
                </>
            )}
            {isUnderReview && (
                <Body color='warn' size='small'>
                    Your campaign enrollment form is now under review! Once approved, you’ll be able
                    to choose a phone number and start sending SMS messages in the Engagement Suite.
                </Body>
            )}
        </div>
    );
}
